/* eslint no-undef: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Helmet } from 'react-helmet'
import { Tabs, Tab, Table } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import EmbededEntityInput from '../input/embedded_entity'
import HelpOverlay from '../utils/helpOverlay'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import orderBy from 'lodash/orderBy'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const ClientEditForm = observer(({ state, selectionState }) => {
  const entity = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.CLIENTS, 'w')
  const selectionStateLength = selectionState && selectionState.get() && selectionState.get().length

  const showFReports = state.cv.record.has('financial_reports') && state.cv.record.get('financial_reports').length > 0
  const showOwnContracts = true // state.cv.owncontracts && state.cv.owncontracts.length > 0
  const showClientPayments = true // state.cv.clientpayments && state.cv.clientpayments.length > 0
  const defaultActiveKey = state.cv.record.has('id') && state.selectedTabClients ? parseInt(state.selectedTabClients) : 1
  const handleActive = tab => { state.selectedTabClients = tab }

  const contractPayments = state.cv.clientpayments || []
  const skipStatus = ['postponed', 'canceled']

  // const totalRevenues = contractPayments.reduce((total, i) => total + parseFloat(i.amount_to_be_paid || 0), 0)
  let totalPayments = 0
  let totalPaymentsWithVat = 0
  let totalRevenues = 0
  let totalPaymentsCalculated = 0
  let totalWireFee = 0
  let totalWithholdingTax = 0
  let totalInProcessingToPaid = 0
  let totalInProcessingTotal = 0

  contractPayments.filter(i => !skipStatus.includes(i.status)).map(i => {
    totalPayments += parseFloat(i.amount_paid || 0)
    totalPaymentsWithVat += parseFloat(i.amount_paid_including_vat || 0)
    totalRevenues += parseFloat(i.amount_to_be_paid || 0)
    if (i.amount_paid !== undefined && i.amount_paid !== null &&
        i.amount_paid !== '' && i.amount_paid.toString().length > 0) {
      totalPaymentsCalculated += parseFloat(i.amount_paid || 0)
      totalWireFee += parseFloat(i.wire_fee || 0)
      totalWithholdingTax += parseFloat(i.withholding_tax_amount || 0)
    }
    if (i.status && (i.status === 'new' || i.status === 'in_processing')) {
      totalInProcessingToPaid += parseFloat(i.amount_to_be_paid || 0)
      totalInProcessingTotal += parseFloat(i.amount_paid || 0) + parseFloat(i.wire_fee || 0) + parseFloat(i.withholding_tax_amount || 0)
    }
  })

  const lastPaymentSorted = orderBy(contractPayments, ['year', 'month', 'id'], ['desc', 'desc', 'desc'])
  const lastPayment = lastPaymentSorted && lastPaymentSorted.length > 0
    ? lastPaymentSorted.shift()
    : null
  const lastPaymentAmount = lastPayment && lastPayment.amount_to_be_paid
    ? parseFloat(lastPayment.amount_to_be_paid)
    : 0
  const lastPaymentCalculated = lastPayment
    ? parseFloat(lastPayment.amount_paid || 0) + parseFloat(lastPayment.wire_fee || 0) + parseFloat(lastPayment.withholding_tax_amount || 0)
    : 0
  const amountCalculatedDifference = parseFloat(lastPaymentAmount - lastPaymentCalculated).toFixed(2)
  totalRevenues = lastPaymentAmount

  const totalRevenuesCalculatedBool = parseFloat(totalPaymentsCalculated + totalWireFee + totalWithholdingTax).toFixed(2) !== parseFloat(totalRevenues).toFixed(2)
  const totalRevenuesInProcessingBool = parseFloat(totalInProcessingToPaid).toFixed(2) !== parseFloat(totalInProcessingTotal).toFixed(2)
  const totalPaymentsWithTaxes = parseFloat(totalPayments + totalWireFee + totalWithholdingTax)
  const statusToHideBool = contractPayments.find(i => ['postponed', 'canceled'].includes(i.status))
  const lastPaymentDifference = parseFloat(totalPaymentsWithTaxes + lastPaymentAmount - lastPaymentCalculated)

  const _taxValuesHelper = (state, row, tax) => {
    const withholdingTax = tax && tax > 0 ? parseFloat(tax) : 0
    const amountToBePaid = row.amount_to_be_paid || 0
    const contractorSelected = row.contractor_id && state.options.get('clients').find(i => i.id === row.contractor_id)
    const contractorSelectedTax = contractorSelected && contractorSelected.withholding_tax && contractorSelected.withholding_tax > 0
      ? parseFloat(contractorSelected.withholding_tax).toFixed(6)
      : parseFloat(0).toFixed(4)
    const contractorTaxCalculated = amountToBePaid > 0 ? (parseFloat(contractorSelectedTax) / 100 * parseFloat(amountToBePaid)).toFixed(2) : 0
    const warningWithholdingTax = amountToBePaid > 0 && parseFloat(contractorTaxCalculated).toFixed(2) !== withholdingTax.toFixed(2)
    return { withholdingTax, warningWithholdingTax, contractorTaxCalculated }
  }

  return (
    <Tabs id='contract_tabs' onSelect={handleActive} defaultActiveKey={
      defaultActiveKey === 2 && !showOwnContracts
        ? 1
        : (defaultActiveKey === 3 && !showOwnContracts
          ? 1
          : (defaultActiveKey === 4 && !showFReports
            ? 1
            : defaultActiveKey))}>
      <Tab eventKey={1} title={
        <div>
          {state.__('Settings')}
          {<HelpOverlay store={state} path='clients/settings' />}
        </div>
      }>
        <div className='row'>
          <Helmet title={state.__(linkConst.LINK_CLIENTS_TITLE).concat(defaultConst.HTML_DIVIDER) + (entity.get('id')
            ? (entity.has('name') ? entity.get('name') : state.__(defaultConst.TITLE_EDIT))
            : state.__(defaultConst.TITLE_CREATE))} />
          <div className='col-sm-12 col-md-4 col-lg-4'>
            <TextInput label={state.__('name')} attr={'name'} record={entity}
              onChange={updateField} errors={errors} disabled={disabled} />
            <TextInput label={state.__('tax id')} attr={'taxid'} record={entity}
              onChange={updateField} errors={errors} disabled={disabled} />
            <TextInput label={state.__('withholding tax (%)')} attr={'withholding_tax'} record={entity}
              type='number' step='0.0001' onChange={updateField} errors={errors} disabled={disabled} />
            <TextInput label={state.__('VAT (%)')} attr={'vat_rate'} record={entity}
              type='number' step='0.0001' onChange={updateField} errors={errors} disabled={disabled} />
          </div>
          <div className='col-sm-12 col-md-8 col-lg-6'>
            <TextInput label={state.__('address')} attr={'address'} record={entity}
              onChange={updateField} errors={errors} disabled={disabled} />
            <TextInput label={state.__('contact')} attr={'contact'} record={entity}
              onChange={updateField} errors={errors} disabled={disabled} />
            <SelectInput
              label={state.__('client type')} attr={'client_type'}
              labelattr='text' valueattr='value' disabled={disabled}
              record={entity} onChange={updateField} errors={errors}
              optionsrecord={state.options} optionsattr={'ClientsType'} />
          </div>
        </div>
      </Tab>

      {!showOwnContracts ? null : <Tab eventKey={2} title={
        <div>
          {state.__('Contracts')}
          {<HelpOverlay store={state} path='clients/contracts' />}
        </div>
      }>
        <EmbededEntityInput disabled disabledRemove
          store={state}
          items={state.cv.owncontracts}
          attr='owncontracts'
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              const DetailLink = ({ text }) => (
                <a href='javascript:void(0)'
                  onClick={() => state.goTo('entity_detail', { entityname: 'contracts', id: row.id })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
                </a>
              )
              return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
            },
            (attr, row) => (
              <OptionsField
                attr={attr}
                val={row[attr]}
                options={state.options.get('ContractTypes')}
                labelattr='text'
                valueattr='value' />
            ),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => null}
        />
      </Tab>}

      {!showClientPayments ? null : <Tab eventKey={3} title={
        <div>
          {state.__('Payments')}
          {<HelpOverlay store={state} path='clients/payments' />}
        </div>
      }>
        <EmbededEntityInput disabled disabledRemove
          addClass='contract-clientpayment-overview'
          store={state}
          items={state.cv.clientpayments}
          attr='clientpayments'
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              const DetailLink = ({ text }) => (
                <a href='javascript:void(0)'
                  onClick={() => state.goTo('entity_detail', { entityname: 'contracts', id: row[attr] })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
                </a>
              )
              return <OptionsField
                attr={attr}
                val={row[attr]}
                options={state.options.get('contracts')}
                labelattr='name' valueattr='id'
                Component={DetailLink} />
            },
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<OptionsField
              attr={attr} val={row[attr]}
              options={state.options.get('ContractPaymentsStatus')}
              labelattr='text' valueattr='value' />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              const { withholdingTax } = _taxValuesHelper(state, row, row.withholding_tax_amount)
              const amountToBePaid = row.amount_to_be_paid || 0
              const amountPaidEx = row.amount_paid || 0
              const isAmountPaidEx = row.amount_paid !== undefined && row.amount_paid !== null &&
                row.amount_paid !== '' && row.amount_paid.toString().length > 0
              const wireFee = row.wire_fee || 0
              const amountPaidCalculated = parseFloat(amountPaidEx) + parseFloat(wireFee) + parseFloat(withholdingTax)
              const revenuesCalculatedBool = amountPaidCalculated.toFixed(2) !== parseFloat(amountToBePaid).toFixed(2)
              return <span className={(revenuesCalculatedBool && isAmountPaidEx) ? 'text-warning' : ''}>
                {isAmountPaidEx ? amountPaidCalculated.toFixed(2) : ' '}
              </span>
            },
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              const { withholdingTax, warningWithholdingTax } = _taxValuesHelper(state, row, row[attr])
              return <span className={warningWithholdingTax ? 'text-warning' : ''}>
                {withholdingTax.toFixed(2).toString()}
              </span>
            },
            (attr, row) => (<DateField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (row[attr] || ''),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => null}
        />
        {(totalRevenues > 0 || totalPaymentsWithVat > 0 || totalPayments > 0) && !state.historicDataFilterActive
          ? <Table striped bordered condensed className='contract-clientpayment-overview'>
            <tbody>
              <tr>
                <th>{state.__('Total')}:</th>
                <th /><th /><th /><th />
                <th />
                <th title={state.__('Amount payable calculated')}>
                  <span className={amountCalculatedDifference !== (0).toFixed(2) ? 'text-warning' : ''}>
                    {totalPayments > 0
                      ? parseFloat(totalPaymentsWithTaxes || 0).toFixed(2)
                      : (0).toFixed(2)}
                  </span>
                </th>
                <th /><th /><th />
                <th title={state.__('Transfer amount')}>
                  <span>{totalPayments > 0
                    ? totalPayments.toFixed(2)
                    : (0).toFixed(2)}
                  </span>
                </th>
                <th title={state.__('Transfer amount (incl. VAT)')}>
                  {<span>{totalPaymentsWithVat > 0
                    ? totalPaymentsWithVat.toFixed(2)
                    : (0).toFixed(2)}
                  </span>}
                </th>
                <th /><th /><th />
              </tr>
            </tbody>
          </Table>
          : null}

        {(totalRevenues > 0 || totalPaymentsWithVat > 0 || totalPayments > 0) && !state.historicDataFilterActive
          ? <Table striped bordered condensed className='contract-clientpayment-overview'>
            <tbody>
              <tr>
                <th colSpan='2' className='contract-clientpayment-colspan2'>{state.__('Amout payable total')}:</th>
                <th /><th /><th />
                <th />
                <th title={state.__('Amout payable total')}> {lastPaymentDifference
                  ? parseFloat(lastPaymentDifference || 0).toFixed(2)
                  : (0).toFixed(2)}
                </th>
                <th title={state.__('Differece between "Amount payable calculated" and "Amout payable total"')}>
                  {state.__('Difference')}:
                </th>
                <th title={state.__('Differece between "Amount payable calculated" and "Amout payable total"')}>
                  <span className={amountCalculatedDifference !== (0).toFixed(2) ? 'text-warning' : 'text-muted'}>
                    {parseFloat(amountCalculatedDifference || 0).toFixed(2)}
                  </span>
                </th>
                <th />
                <th />
                <th />
                <th /><th /><th />
              </tr>
            </tbody>
          </Table>
          : null}
      </Tab>}

      {!showFReports ? null : <Tab eventKey={4} title={state.__('Financial reports')}>
        <button className='btn btn-primary' type='button' disabled={!selectionStateLength}
          onClick={state.downloadFinancialReports.bind(state, { selectionState, customItems: entity.get('financial_reports') })}>
          <span className='glyphicon glyphicon-download' />&nbsp;
          {state.__('Download selected')}
          {selectionStateLength ? ` (${selectionStateLength}x)` : ''}
        </button>
        <EmbededEntityInput disabled disabledRemove
          store={state}
          attr='financial_reports'
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              return <TextField attr={attr} val={row.id} Component={({ text }) => (
                <a href={`${Conf.url}/financial_reports/report/${encodeURIComponent(row.s3path)}?token=${state.authToken}`}
                  target='_blank' rel='noreferrer' title={row.s3path}><span className='glyphicon glyphicon-file' />
                </a>
              )} />
            },
            (attr, row) => {
              const contractTitle = row[attr] && state.options.get('contracts').find(i => i.id === row[attr])
              const DetailLink = ({ text }) => (
                <a className='item-link-width' title={state.__('Click to open detail')} href='javascript:void(0)'
                  onClick={() => state.goTo('entity_detail', { entityname: 'contracts', id: row.contract_id })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;
                  {contractTitle
                    ? contractTitle.name
                    : row[attr]}
                </a>
              )
              return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
            },
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => null}
          selectionState={selectionState}
        />
      </Tab>}

    </Tabs>
  )
})

ClientEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const ClientEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.CLIENTS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.CLIENTS, 'w')} >
      <ClientEditForm state={store} selectionState={observable.box([])} />
    </EditView>
  )
}
export default ClientEditView
